import Layout from '@/layout';
import ActConfRouter from '../../../cloudserver/router/activityConf';

export default ActConfRouter(Layout, 'pc');
